import React, { useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { JhiItemCount, JhiPagination, TextFormat, getPaginationState } from 'react-jhipster';
import { Link, useLocation, useNavigate } from 'react-router';

import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';

import { getEntities } from './estatus.reducer';

export const Estatus = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const estatusList = useAppSelector(state => state.estatus.entities);
  const loading = useAppSelector(state => state.estatus.loading);
  const totalItems = useAppSelector(state => state.estatus.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const { order } = paginationState;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="estatus-heading" data-cy="EstatusHeading">
        Estatuses
        <div className="d-flex justify-content-end">
          <Button className="me-2" variant="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} /> Refresh list
          </Button>
          <Link to="/estatus/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp; Create a new Estatus
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {estatusList?.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  ID <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('idMensajeCobro')}>
                  Id Mensaje Cobro <FontAwesomeIcon icon={getSortIconByFieldName('idMensajeCobro')} />
                </th>
                <th className="hand" onClick={sort('cc')}>
                  Cc <FontAwesomeIcon icon={getSortIconByFieldName('cc')} />
                </th>
                <th className="hand" onClick={sort('mt')}>
                  Mt <FontAwesomeIcon icon={getSortIconByFieldName('mt')} />
                </th>
                <th className="hand" onClick={sort('hs')}>
                  Hs <FontAwesomeIcon icon={getSortIconByFieldName('hs')} />
                </th>
                <th className="hand" onClick={sort('hp')}>
                  Hp <FontAwesomeIcon icon={getSortIconByFieldName('hp')} />
                </th>
                <th className="hand" onClick={sort('e')}>
                  E <FontAwesomeIcon icon={getSortIconByFieldName('e')} />
                </th>
                <th className="hand" onClick={sort('cr')}>
                  Cr <FontAwesomeIcon icon={getSortIconByFieldName('cr')} />
                </th>
                <th className="hand" onClick={sort('ncVendedor')}>
                  Nc Vendedor <FontAwesomeIcon icon={getSortIconByFieldName('ncVendedor')} />
                </th>
                <th className="hand" onClick={sort('dvVendedor')}>
                  Dv Vendedor <FontAwesomeIcon icon={getSortIconByFieldName('dvVendedor')} />
                </th>
                <th className="hand" onClick={sort('tcVendedor')}>
                  Tc Vendedor <FontAwesomeIcon icon={getSortIconByFieldName('tcVendedor')} />
                </th>
                <th className="hand" onClick={sort('cbVendedor')}>
                  Cb Vendedor <FontAwesomeIcon icon={getSortIconByFieldName('cbVendedor')} />
                </th>
                <th className="hand" onClick={sort('ciVendedor')}>
                  Ci Vendedor <FontAwesomeIcon icon={getSortIconByFieldName('ciVendedor')} />
                </th>
                <th className="hand" onClick={sort('nbVendedor')}>
                  Nb Vendedor <FontAwesomeIcon icon={getSortIconByFieldName('nbVendedor')} />
                </th>
                <th className="hand" onClick={sort('ncClient')}>
                  Nc Client <FontAwesomeIcon icon={getSortIconByFieldName('ncClient')} />
                </th>
                <th className="hand" onClick={sort('dvClient')}>
                  Dv Client <FontAwesomeIcon icon={getSortIconByFieldName('dvClient')} />
                </th>
                <th className="hand" onClick={sort('tcClient')}>
                  Tc Client <FontAwesomeIcon icon={getSortIconByFieldName('tcClient')} />
                </th>
                <th className="hand" onClick={sort('cbClient')}>
                  Cb Client <FontAwesomeIcon icon={getSortIconByFieldName('cbClient')} />
                </th>
                <th className="hand" onClick={sort('ciClient')}>
                  Ci Client <FontAwesomeIcon icon={getSortIconByFieldName('ciClient')} />
                </th>
                <th className="hand" onClick={sort('nbClient')}>
                  Nb Client <FontAwesomeIcon icon={getSortIconByFieldName('nbClient')} />
                </th>
                <th className="hand" onClick={sort('extra1')}>
                  Extra 1 <FontAwesomeIcon icon={getSortIconByFieldName('extra1')} />
                </th>
                <th className="hand" onClick={sort('extra2')}>
                  Extra 2 <FontAwesomeIcon icon={getSortIconByFieldName('extra2')} />
                </th>
                <th className="hand" onClick={sort('extra3')}>
                  Extra 3 <FontAwesomeIcon icon={getSortIconByFieldName('extra3')} />
                </th>
                <th className="hand" onClick={sort('extra4')}>
                  Extra 4 <FontAwesomeIcon icon={getSortIconByFieldName('extra4')} />
                </th>
                <th className="hand" onClick={sort('extra5')}>
                  Extra 5 <FontAwesomeIcon icon={getSortIconByFieldName('extra5')} />
                </th>
                <th className="hand" onClick={sort('extra6')}>
                  Extra 6 <FontAwesomeIcon icon={getSortIconByFieldName('extra6')} />
                </th>
                <th className="hand" onClick={sort('extra7')}>
                  Extra 7 <FontAwesomeIcon icon={getSortIconByFieldName('extra7')} />
                </th>
                <th className="hand" onClick={sort('extra8')}>
                  Extra 8 <FontAwesomeIcon icon={getSortIconByFieldName('extra8')} />
                </th>
                <th className="hand" onClick={sort('extra9')}>
                  Extra 9 <FontAwesomeIcon icon={getSortIconByFieldName('extra9')} />
                </th>
                <th className="hand" onClick={sort('extra10')}>
                  Extra 10 <FontAwesomeIcon icon={getSortIconByFieldName('extra10')} />
                </th>
                <th className="hand" onClick={sort('createdBy')}>
                  Created By <FontAwesomeIcon icon={getSortIconByFieldName('createdBy')} />
                </th>
                <th className="hand" onClick={sort('createdDate')}>
                  Created Date <FontAwesomeIcon icon={getSortIconByFieldName('createdDate')} />
                </th>
                <th className="hand" onClick={sort('lastModifiedBy')}>
                  Last Modified By <FontAwesomeIcon icon={getSortIconByFieldName('lastModifiedBy')} />
                </th>
                <th className="hand" onClick={sort('lastModifiedDate')}>
                  Last Modified Date <FontAwesomeIcon icon={getSortIconByFieldName('lastModifiedDate')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {estatusList.map(estatus => (
                <tr key={`entity-${estatus.id}`} data-cy="entityTable">
                  <td>
                    <Button as={Link as any} to={`/estatus/${estatus.id}`} variant="link" size="sm">
                      {estatus.id}
                    </Button>
                  </td>
                  <td>{estatus.idMensajeCobro}</td>
                  <td>{estatus.cc}</td>
                  <td>{estatus.mt}</td>
                  <td>{estatus.hs}</td>
                  <td>{estatus.hp}</td>
                  <td>{estatus.e}</td>
                  <td>{estatus.cr}</td>
                  <td>{estatus.ncVendedor}</td>
                  <td>{estatus.dvVendedor}</td>
                  <td>{estatus.tcVendedor}</td>
                  <td>{estatus.cbVendedor}</td>
                  <td>{estatus.ciVendedor}</td>
                  <td>{estatus.nbVendedor}</td>
                  <td>{estatus.ncClient}</td>
                  <td>{estatus.dvClient}</td>
                  <td>{estatus.tcClient}</td>
                  <td>{estatus.cbClient}</td>
                  <td>{estatus.ciClient}</td>
                  <td>{estatus.nbClient}</td>
                  <td>{estatus.extra1}</td>
                  <td>{estatus.extra2}</td>
                  <td>{estatus.extra3}</td>
                  <td>{estatus.extra4}</td>
                  <td>{estatus.extra5}</td>
                  <td>{estatus.extra6}</td>
                  <td>{estatus.extra7}</td>
                  <td>{estatus.extra8}</td>
                  <td>{estatus.extra9}</td>
                  <td>{estatus.extra10}</td>
                  <td>{estatus.createdBy}</td>
                  <td>{estatus.createdDate ? <TextFormat type="date" value={estatus.createdDate} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{estatus.lastModifiedBy}</td>
                  <td>
                    {estatus.lastModifiedDate ? <TextFormat type="date" value={estatus.lastModifiedDate} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button as={Link as any} to={`/estatus/${estatus.id}`} variant="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button
                        as={Link as any}
                        to={`/estatus/${estatus.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        variant="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button
                        onClick={() =>
                          (globalThis.location.href = `/estatus/${estatus.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        variant="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Estatuses found</div>
        )}
      </div>
      {totalItems ? (
        <div className={estatusList && estatusList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Estatus;
